import { render, staticRenderFns } from "./payInit.vue?vue&type=template&id=4e0b9ec3&scoped=true"
import script from "./payInit.vue?vue&type=script&lang=js"
export * from "./payInit.vue?vue&type=script&lang=js"
import style0 from "./payInit.vue?vue&type=style&index=0&id=4e0b9ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b9ec3",
  null
  
)

export default component.exports